import {
  Component,
  Input,
  OnInit,
  QueryList,
  Self,
  ViewChildren,
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomPaggerService } from 'projects/Autofacets-Core/src/app/common-services/custom-pagger.service';
import {
  NgbdSortableHeader,
  SortEvent,
} from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import { CampaignStepType } from '../../../../business-entities/campaign-list-model';
import { CampaignTemplateModel } from '../../../../business-entities/campaign-template-model';
import { CampaignTemplateService } from '../../../../business-services/campaign-template.service';

@Component({
  selector: 'app-email-template-model',
  templateUrl: './email-template-model.component.html',
  providers: [CustomPaggerService],
})
export class EmailTemplateModelComponent implements OnInit {
  @Input() templateType: any;
  @Input() selectedTemplateId: any;
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;

  template: CampaignTemplateModel[];
  stepType = CampaignStepType;
  searchTerm = '';
  totalCount = 0;
  scrollDistance = 1;
  throttle = 100;

  constructor(
    private activeModal: NgbActiveModal,
    @Self() public pService: CustomPaggerService,
    private campaignTemplateService: CampaignTemplateService
  ) {
    this.pService.pageSize = 10;
    this.pService.searchby = ['Name', 'Subject'];
    this.pService.searchTerm = '';
  }

  ngOnInit(): void {
    this.getTemplate();
  }

  ngOnDestroy(): void {
    if (this.pService) {
      this.pService._dealers$.unsubscribe();
    }
  }

  OnClose() {
    this.activeModal.close({
      success: true,
      template: this.template.find((x) => x.id == this.selectedTemplateId),
    });
  }

  onSort({ column, direction }: SortEvent) {
    // resetting other headers
    this.headers.forEach((header) => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    this.pService.sortColumn = column;
    this.pService.sortDirection = direction;
  }

  getTemplate() {
    this.template = [];
    this.campaignTemplateService
      .getTemplateByChannel(this.templateType)
      .then((response) => {
        if (response && response.statusCode == 200) {
          if (response.data?.length > 0) {
            this.template = response.data;
            this.totalCount = response.data[0].totalCount;
          }
        }
      });
  }
  onScrollDown(_ev) {
    if (this.totalCount > this.template.length) {
      this.templateType.startRecordNumber = this.template.length;
      this.getTemplate();
    }
  }
}
